import { cn } from "@/lib/utils";

interface DotProps {
  className?: string;
}

export const Dot = ({ className }: DotProps) => (
  <div
    className={cn(
      "inline-block w-4 h-4 mr-2 bg-secondary rounded-full",
      className
    )}
  />
);
